import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Los protocolos de patologías en un solo lugar. El de SII con FODMAPs es oro puro.',
    author: 'Laura P.',
    location: 'Rosario',
    initial: 'L'
  }, {
    quote: 'El guion de primera consulta fue un antes y un después. Ahora sé cómo cerrar para que el paciente vuelva.',
    author: 'Roberto M.',
    location: 'Buenos Aires',
    initial: 'R'
  }, {
    quote: "Los 12 menús del Bono 6 me ahorran una hora por semana. Las listas de compras resuelven el 'no sé qué comprar'.",
    author: 'Julia M.',
    location: 'Tucumán',
    initial: 'J'
  }, {
    quote: 'Las analogías del Bono 5 cambiaron cómo explico. Mis pacientes entienden el IG en 15 segundos.',
    author: 'Valeria L.',
    location: 'Rosario',
    initial: 'V'
  }];
  const Stars = () => <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-315">
      {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-316" />)}
    </div>;
  return <section className="py-14 px-4 max-w-6xl mx-auto bg-black" data-id="element-317">
      <FadeIn data-id="element-318">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-319">
          <span className="text-red-500" data-id="element-320">❤️</span> LO QUE DICEN LAS QUE YA LO
          TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-321">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-322">
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8 h-full" data-id="element-323">
              <Stars data-id="element-324" />
              <p className="text-lg text-gray-200 mb-6 italic leading-relaxed" data-id="element-325">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-326">
                <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 font-bold" data-id="element-327">
                  {t.initial}
                </div>
                <div data-id="element-328">
                  <p className="font-bold text-white" data-id="element-329">{t.author}</p>
                  <p className="text-sm text-gray-500" data-id="element-330">{t.location}</p>
                </div>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}